import { gql } from '@apollo/client'

export const CREATE_REFERRALS = gql`
	mutation createStaffingReferralWorkerMutation {
		createStaffingReferralWorker {
			acceptUrl
			applyUrl
			externalId
			id
			joinUrl
		}
	}
`
